let switchErrors = function(error, componente, excepciones = []) {
  let mensaje = "";
  let titulo = "";
  let tipo = "onError";
  let dobleBotonera = false;
  let ayuda = false;
  if (error && (error.data || error.response || error.status)) {
    if (excepciones.length > 0) {
      let codigoError = error.status || error.response.status;
      let excepcion = excepciones.find(excepcionTemp => {
        return "" + excepcionTemp.codigo === "" + codigoError;
      });
      if (excepcion) {
        mensaje = excepcion.mensaje;
      }
    } else {
      switch (error.status || error.response.status) {
        case 400:
          if (error.data && error.data.errores) {
            let values = Object.keys(error.data.errores).map(function(key) {
              return dictionary[key];
            });
            mensaje = values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.errores) {
              let values = Object.keys(error.response.data.errores).map(
                function(key) {
                  return error.response.data.errores[key][0];
                }
              );
              mensaje = values[0];
            }
          }
          break;
        case 500:
          titulo = "Error";
            mensaje =
              "No se ha podido realizar la operación, por favor intentar de nuevo.";
            ayuda = true;
          break;
        default:
          titulo = "Error";
          mensaje =
            "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad";
      }
    }
  } else {
    if (error.message) {
      mensaje = error.message;
    } else {
      mensaje =
        "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad";
    }
  }
  if (mensaje.length > 0) {
    componente.$emit(tipo, mensaje, titulo, dobleBotonera, ayuda);
  } else {
    console.warn("Error sin mensaje");
  }
};

export default { switchErrors };



// WEBPACK FOOTER //
// ./src/utils/Errores.js